import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CancelMyBidMutationResponse, CancelMyBidQueryParams } from "../../types/CancelMyBid";

/**
     * @link /api/purchase-tenders/v1/bids/cancel_my_bids
     */
export async function cancelMyBid (params: CancelMyBidQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CancelMyBidMutationResponse>["data"]> {
    const { data: resData } = await client<CancelMyBidMutationResponse>({
        method: "delete",
        url: `/api/purchase-tenders/v1/bids/cancel_my_bids`,
        params,
        ...options
    });
    
    return resData;
};